import { useRef } from 'react';

function useLatest<T>(data: T) {
  const dataRef = useRef<T>(data);

  dataRef.current = data;

  return dataRef;
}

export default useLatest;
